import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import Section from 'settings-ui-lib/components/Section';
import SettingsRowCheckbox from 'settings-ui-lib/components/SettingsRowCheckbox';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { updateHideFollowUpPopoverSetting, updateHideLeadFollowUpPopoverSetting } from '../../reducers/stagedSettingsReducer';
import { hideFollowUpPopoverSettingSelector, hideLeadFollowUpPopoverSettingSelector } from '../../selectors/SettingsSelectors';
import { trackFollowUpReminderSettingChanged, trackLeadFollowUpReminderSettingChanged } from '../../usage/tracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function FollowUpPopoverSection() {
  const dispatch = useDispatch();
  // the stored setting is the NOT of the checkbox value
  const isFollowUpTaskChecked = !useSelector(hideFollowUpPopoverSettingSelector);
  const handleToggleTaskFollowUpSetting = useCallback(({
    target: {
      checked
    }
  }) => {
    // the stored setting is the NOT of the checkbox value
    dispatch(updateHideFollowUpPopoverSetting(!checked));
    trackFollowUpReminderSettingChanged(checked);
  }, [dispatch]);
  const isLeadFollowUpTaskChecked = !useSelector(hideLeadFollowUpPopoverSettingSelector);
  const handleToggleLeadFollowUpSetting = useCallback(({
    target: {
      checked
    }
  }) => {
    // the stored setting is the NOT of the checkbox value
    dispatch(updateHideLeadFollowUpPopoverSetting(!checked));
    trackLeadFollowUpReminderSettingChanged(checked);
  }, [dispatch]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "REMINDERS_SETTING"
    }), /*#__PURE__*/_jsxs(Section, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "CrmSettingsTaskReminders.reminders.sectionHeader"
      }),
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "CrmSettingsTaskReminders.reminders.sectionSubCopy"
      }),
      children: [/*#__PURE__*/_jsx(SettingsRowCheckbox, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "CrmSettingsTaskReminders.reminders.toggleLabel"
        }),
        input: /*#__PURE__*/_jsx(Checkbox, {
          "data-test-id": "follow-up-task-setting",
          checked: isFollowUpTaskChecked,
          onChange: handleToggleTaskFollowUpSetting
        })
      }), /*#__PURE__*/_jsx(SettingsRowCheckbox, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "CrmSettingsTaskReminders.reminders.leadFollowUpLabel"
        }),
        input: /*#__PURE__*/_jsx(Checkbox, {
          "data-test-id": "lead-follow-up-task-setting",
          checked: isLeadFollowUpTaskChecked,
          onChange: handleToggleLeadFollowUpSetting
        })
      })]
    })]
  });
}